import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ForwardedRef, ReactNode } from 'react';

import useBackgroundIsDark from '../../hooks/useBackgroundIsDark';

import AuthorsList, { AuthorsListProps } from '../lists/AuthorsList';
import Background from '../partials/Background';

import styles from '../../styles/blocks/authors-row-block.module.css';

interface AuthorsRowBlockProps extends AuthorsListProps {
    title?: ReactNode;
    header?: ReactNode;
    footer?: ReactNode;
    background?: Background | string | null;
    count?: number;
    withShadow?: boolean | null;
    withBorderRadius?: boolean;
    className?: string | null;
    titleClassName?: string | null;
    innerClassName?: string | null;
    listClassName?: string | null;
    itemsClassName?: string | null;
    backgroundClassName?: string | null;
}

function AuthorsRowBlock({
    title = null,
    header = null,
    footer = null,
    background = null,
    count = 12,
    withShadow = null,
    withBorderRadius = false,
    className = null,
    titleClassName = null,
    innerClassName = null,
    listClassName = null,
    itemsClassName = null,
    backgroundClassName = null,
    ref = null,
    ...props
}: AuthorsRowBlockProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    const finalBackground = isString(background) ? { color: background } : background;

    const backgroundIsDark = useBackgroundIsDark(finalBackground);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.textIsWhite]: backgroundIsDark,
                    [styles.withBorderRadius]: withBorderRadius,
                    [styles.withShadow]: withShadow,
                },
                className,
            ])}
            ref={ref}
        >
            <div className={classNames([styles.inner, innerClassName])}>
                {finalBackground !== null ? (
                    <Background
                        {...finalBackground}
                        className={classNames([styles.background, backgroundClassName])}
                    />
                ) : null}

                {header ||
                    (title !== null ? (
                        <div className={classNames([styles.title, titleClassName])}>{title}</div>
                    ) : null)}
                <div className={classNames([styles.list, listClassName])}>
                    <AuthorsList
                        presentation="responsive"
                        cardWidth={150}
                        itemsClassName={classNames([styles.items, itemsClassName])}
                        cardClassName={styles.card}
                        cardSize="small"
                        placeholderCount={count}
                        minColumns={2}
                        count={count}
                        {...props}
                    />
                </div>
                {footer}
            </div>
        </div>
    );
}

export default AuthorsRowBlock;
